import FormRow from 'components/FormRow';
import Input from 'components/ui/Input';
import styled from 'styled-components';
import { RightSideBarContent, RightSideBarHeader } from 'styles/commonStyles';
import useHyperparameter from './hooks/useHyperparameter';
import ToggleCheckbox from 'components/ui/ToggleCheckbox';
import Slider from 'components/ui/Slider';
import { useRecoilValue } from 'recoil';
import { rightSideBarFullState } from 'state/atoms';

const Container = styled.form<{ $isFull: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0px;
  width: ${(props) => (props.$isFull ? '460px' : 'initial')};

  & > div {
    height: 54px;
    display: flex;

    & > div {
      width: 100%;
    }
  }
`;

const SliderView = styled.div`
  padding: 4px 0px;
`;

const HyperparameterViewer = () => {
  const isFull = useRecoilValue(rightSideBarFullState);
  const { makeVal, dataRatio, register, onBlur, onMakeValChange, onRatioChange, onValueChange } = useHyperparameter();

  return (
    <RightSideBarContent>
      <RightSideBarHeader>
        <h1>하이퍼 파라미터</h1>
      </RightSideBarHeader>
      <Container $isFull={isFull}>
        <FormRow
          label="데이터 폴더 경로"
          direction="row"
          tooltipId="hyperparamter-datapath"
          tooltip="데이터를 넣고 사용할 폴더 경로를 입력해주세요"
        >
          <Input
            {...register('dataPath', {
              onBlur,
              onChange: onValueChange,
            })}
            style={{ width: '160px' }}
          />
        </FormRow>
        <FormRow
          label="최대 에폭"
          direction="row"
          tooltipId="hyperparameter-maxepochs"
          tooltip="학습할 에폭을 입력해주세요"
        >
          <Input
            type="number"
            {...register('maxEpochs', {
              onBlur,
              onChange: onValueChange,
            })}
            style={{ width: '90px' }}
          />
        </FormRow>
        <FormRow
          label="배치 사이즈"
          direction="row"
          tooltipId="hyperparameter-batchsize"
          tooltip="배치 사이즈를 입력해주세요"
        >
          <Input
            type="number"
            {...register('batchSize', {
              onBlur,
              onChange: onValueChange,
            })}
            style={{ width: '90px' }}
          />
        </FormRow>
        <FormRow
          label="조기 종료 결정 에폭 (미사용: 0)"
          direction="row"
          tooltipId="hyperparameter-earlystop"
          tooltip={`오버피팅 방지를 위해 조기종료(Early stop)를 사용하실 경우,\n오버피팅을 판단할 에폭 수를 입력해주세요`}
        >
          <Input
            type="number"
            {...register('earlyStop', {
              onBlur,
              onChange: onValueChange,
            })}
            style={{ width: '90px' }}
          />
        </FormRow>
        <FormRow
          label="학습 데이터 섞기 (셔플)"
          direction="row"
          tooltipId="hyperparameter-shuffle"
          tooltip="학습 데이터 셔플(Shuffle)이 필요한 경우 체크해주세요"
        >
          <ToggleCheckbox
            id="shuffle"
            {...register('shuffle', {
              onBlur,
              onChange: onValueChange,
            })}
          />
        </FormRow>
        <FormRow
          label="검증 데이터 사용하기"
          direction="row"
          tooltipId="hyperparameter-useval"
          tooltip="검증 데이터를 사용하실 경우 체크해주세요"
        >
          <ToggleCheckbox
            id="useVal"
            {...register('useVal', {
              onBlur,
              onChange: onValueChange,
            })}
          />
        </FormRow>
        <FormRow
          label="학습 데이터로부터 검증 데이터 만들기"
          direction="row"
          tooltipId="hyperparameter-makeval"
          tooltip={`검증 데이터가 없는 상태이지만 학습 데이터로부터\n검증 데이터를 만들어서 사용하시려면 체크해주세요`}
        >
          <ToggleCheckbox
            id="makeVal"
            {...register('makeVal', {
              onBlur,
              onChange: onMakeValChange,
            })}
          />
        </FormRow>
        {makeVal && (
          <>
            <FormRow
              label="학습 데이터 비율"
              direction="row"
              tooltipId="hyperparameter-dataratio"
              tooltip="검증 데이터 사용시 학습 데이터 비율을 입력해주세요"
            >
              <Input
                type="number"
                {...register('dataRatio', {
                  onBlur,
                  onChange: onValueChange,
                })}
                style={{ width: '90px' }}
              />
            </FormRow>
            <SliderView>
              <Slider ratio={Number(dataRatio)} min={0} max={0.99} onRatioChange={onRatioChange} />
            </SliderView>
          </>
        )}
      </Container>
    </RightSideBarContent>
  );
};

export default HyperparameterViewer;
